import { render, staticRenderFns } from "./imprimir-pauta_2020_kilamba.vue?vue&type=template&id=41f9f37d&"
import script from "./imprimir-pauta_2020_kilamba.vue?vue&type=script&lang=js&"
export * from "./imprimir-pauta_2020_kilamba.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports